export default __webpack_public_path__ + "static/media/cat7-4.8013242e.jpg";